import withErrorCheck from "../CheckError";
import server from "../Server";
import type { IPlayerSeasonStats } from "@grassrootly/api/entities";

export interface GetSeasonStatisticsPayload {
  seasonId: number;
  dateFrom?: string | null;
  dateTo?: string | null;
}

// Fetch player statistics for a season using get_player_season_stats SQL function
export const GetSeasonStatistics = async ({
  seasonId,
  dateFrom = null,
  dateTo = null,
}: GetSeasonStatisticsPayload): Promise<IPlayerSeasonStats[]> => {
  const response = await server.rpc("get_player_season_stats", {
    p_season_id: seasonId,
    p_date_from: dateFrom,
    p_date_to: dateTo,
  });

  const data = withErrorCheck<IPlayerSeasonStats[]>(response as any) || [];
  return data;
};
